module.exports = __webpack_public_path__ + "img/Schnell-Einsatz-Gruppe_Betreuung.b31fa205.svg";